export default "__VITE_ASSET__1f4e4a0a__"